<template>

<core-modal v-on:close="onClose" :is-empty="!items.length"  :nopadding="true">

	<template v-slot:head>

		Manage Tags

	</template>

	<template v-slot:default>

		<template v-for="item in items">

			<com-tag :key="item.id" :tag="item" v-if="item.isTag" />
			<com-family :key="item.id" :family="item" v-if="item.isFamily" />

		</template>

        <div class="manage-empty" v-if="!items.length">

            No tags created.

        </div>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onCreateTagClick">Create Tag</core-button>

		<core-button theme="blue" v-on:click.native="onCreateFamilyClick">Create Family</core-button>

	</template>

</core-modal>

</template>

<script>

import comTag from './manage/Tag'
import comFamily from './manage/Family'

export default {

	props: ['data'],

	components: {
		'com-tag': comTag,
		'com-family': comFamily
	},
	
	data: function() {

		return {

			is: {
				loading: false
			}

		}

	},

	computed: {

		items: function() {

			var items = []

			this.$_.each(this.tags, function(tag) {

				tag = this.$util.copy(tag)
				tag.sort = tag.text
				tag.isTag = true

				items.push(tag)

			}.bind(this))

			this.$_.each(this.families, function(family) {

				family = this.$util.copy(family)
				family.sort = family.name
				family.isFamily = true

				items.push(family)

			}.bind(this))

			items = this.$_.sortBy(items, function(item) {

				return item.sort.toLowerCase()

			})

			return items

		},

		tags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return !tag.family

			})

		},

		families: function() {

			return this.$store.getters['data/tagFamilies/list']

		}

	},

	methods: {

        onCreateTagClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagCreate',
				manage: true
			})	

        },

        onCreateFamilyClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagFamilyCreate',
				manage: true
			})	

        },

		onClose: function() {

			this.$emit('close')

		}

	}

}

</script>

<style scoped>

.manage-empty {
    position: absolute;
    left: 0%;
    top: 50%;
    width: 100%;
    font-size: 20px;
    color: #fff;
    opacity: 0.75;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    padding: 16px;
}

</style>